import React from "react";

const approach = [
  {
    title: "Business-First Planning",
    text: "Every recommendation starts with your business objectives instead of technology.",
  },
  {
    title: "Experienced Shopify Developers",
    text: "Our team develops Shopify solutions that are practical, scalable, and easy to manage.",
  },
  {
    title: "Custom Development",
    text: "We build features around your operations instead of relying only on third-party apps.",
  },
  {
    title: "Transparent Communication",
    text: "You stay informed throughout planning, development, testing, and launch.",
  },
  {
    title: "Long-Term Partnership",
    text: "We keep supporting your Shopify Plus store after launch. This includes maintenance, improvements, and technical advice.",
  },
];

export default function Section7() {
  return (
    <div className="w-full Section7 pb-[4%] pt-0 md:pt-[30px]">
      <div className="w-full mx-auto section7-container">
        <div className="w-[90%] md:w-[70%] mx-auto text-center pb-[3%]">
          <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
            Why Businesses Choose Mean3 for Shopify Plus in UAE
          </h2>
          <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
            Choosing the right Shopify Plus development partner is important
            for businesses that want a reliable ecommerce platform. At
            Mean3, we focus on understanding your business goals, customer
            needs, and technical requirements before creating a solution.
          </p>
          <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
            Based in Dubai, we help businesses across the UAE build Shopify
            Plus stores that are easy to manage, scalable, and designed for
            long-term growth. Our team focuses on practical solutions that
            support your ecommerce operations.
          </p>
        </div>

        <p className="text-center font-bold text-[#151515] text-sm md:text-base font-open mb-[3%]">
          Our approach includes:
        </p>

        <div className="boxes w-[90%] md:w-[85%] flex justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] flex-wrap mx-auto pb-[3%]">
          {approach.map((item, index) => (
            <div
              key={item.title}
              className={`w-full xs:w-[45%] md:w-[30%] p-[5%] rounded-[6px] ${
                (index + 1) % 2 === 0
                  ? "text-[#373737] bg-[#F5F5F5]"
                  : "bg-[#E42E35] text-white"
              }`}
            >
              <h3 className="text-[17px] md:text-[19px] font-bold leading-[24px] my-[0.5em] pb-[2%]">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm leading-[20px] font-open">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <p className="w-[90%] md:w-[61%] mx-auto text-center leading-[22px] text-[#373737] text-sm md:text-base font-open pb-[4%] pt-[30px] md:pt-0">
          Whether you need Shopify Plus in UAE, or enterprise ecommerce
          development for international markets, our team is ready to help.
        </p>
      </div>
      <div className="line mt-[55px] md:mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}